import { useState } from "react";
import Reveal from "@/components/feature/Reveal";
import { fileItems } from "@/mocks/homeFiles";

export default function FileSection() {
  const [activeId, setActiveId] = useState<string | null>(null);

  return (
    <section id="files" className="w-full border-b border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-[1440px] px-4 py-10 md:px-8 md:py-14">
        <Reveal>
          <div className="mb-6 flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
            <div>
              <span className="text-xs font-medium tracking-widest text-secondary-700">
                MATERIALS
              </span>
              <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
                材料下载与索引
              </h2>
            </div>
            <p className="max-w-lg text-sm leading-relaxed text-foreground-600">
              每份材料都注明页数、体积和下载量，不确定先下哪份时，可以从体积小、下载多的索引清单开始。
            </p>
          </div>
        </Reveal>

        <Reveal>
          <div className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
            <div className="hidden grid-cols-12 gap-4 border-b border-background-200 bg-background-100 px-5 py-3 text-xs font-medium text-foreground-500 md:grid">
              <span className="col-span-6">材料名称</span>
              <span className="col-span-2">规格</span>
              <span className="col-span-2">体积</span>
              <span className="col-span-2 text-right">操作</span>
            </div>

            <ul>
              {fileItems.map((file, index) => (
                <li
                  key={file.id}
                  className={`flex flex-col gap-3 px-5 py-4 transition-colors hover:bg-background-100 md:grid md:grid-cols-12 md:items-center md:gap-4 ${
                    index !== 0 ? "border-t border-background-200" : ""
                  }`}
                >
                  <div className="flex items-start gap-3 md:col-span-6">
                    <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-secondary-100 text-secondary-800">
                      <i className={`${file.icon} text-lg`}></i>
                    </span>
                    <div className="min-w-0">
                      <p className="truncate text-sm font-medium text-foreground-900">
                        {file.name}
                      </p>
                      <p className="mt-1 flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-foreground-500">
                        <span className="rounded bg-background-200 px-1.5 py-0.5 font-medium text-foreground-700">
                          {file.type}
                        </span>
                        <span>{file.pages}</span>
                        <span className="md:hidden">{file.size}</span>
                        <span className="inline-flex items-center gap-1">
                          <i className="ri-download-2-line"></i>
                          {file.downloads}
                        </span>
                      </p>
                    </div>
                  </div>

                  <span className="hidden text-sm text-foreground-600 md:col-span-2 md:block">
                    {file.pages}
                  </span>
                  <span className="hidden text-sm text-foreground-600 md:col-span-2 md:block">
                    {file.size}
                  </span>

                  <div className="flex items-center justify-between gap-3 md:col-span-2 md:justify-end">
                    <span className="text-xs text-foreground-400 md:hidden">{file.updatedAt}</span>
                    <button
                      type="button"
                      onClick={() => setActiveId(file.id)}
                      className={`inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md px-3.5 py-2 text-xs font-medium transition-colors ${
                        activeId === file.id
                          ? "bg-primary-600 text-background-50"
                          : "bg-primary-500 text-background-50 hover:bg-primary-600"
                      }`}
                    >
                      <i className="ri-download-line"></i>
                      {activeId === file.id ? "已加入队列" : "下载"}
                    </button>
                  </div>
                </li>
              ))}
            </ul>

            <div className="flex flex-col gap-2 border-t border-background-200 bg-background-100 px-5 py-4 sm:flex-row sm:items-center sm:justify-between">
              <p className="text-xs leading-relaxed text-foreground-500">
                <i className="ri-flashlight-line mr-1 align-middle"></i>
                下载为页面演示效果，正式上线后会跳转到对应的材料地址。
              </p>
              <span className="whitespace-nowrap text-xs text-foreground-500">
                共 6 份 · 最近更新 09-10
              </span>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}